<button 
    class="button"
     [ngClass]="[
        prefixClass, 
        variant === 'outlined' ? 'button--outlined' : '', 
        variant === 'filled' ? 'button--filled' : '', 
        variant === 'text' ? 'button--text' : ''
    ]"
    [ngStyle]="{'width': fullWidth ? '100%' : ''}"
    [disabled]="disabled || loading"
    [attr.disabled]="disabled || loading ? true : null"
    [attr.aria-label]="label"
    [class.loading]="loading"
>
    <span>{{ label }}</span>
    <app-icon *ngIf="iconName" [iconName]="iconName" [iconSize]="'24px'" [color]="'#FFFFFF'"></app-icon>
    <span *ngIf="loading" class="spinner"></span>
</button>